import {
  InfoPopoverContentWrapper,
  InfoPopoverText,
} from '@framework/ui/components/popover/InfoPopoverContent.tsx';

/**
 * Contenuto del popover ⓘ del campo "Codice" nella configurazione widget
 * (usato da CodeLabelInputForm).
 */
export function WidgetCodeInfoPopover() {
  return (
    <InfoPopoverContentWrapper>
      <InfoPopoverText>
        Il Codice non è visibile a chi compila. Viene usato per fare riferimento
        al campo da altri elementi (valori calcolati, condizioni di visibilità e
        abilitazione) e nell&apos;esportazione dei dati.
      </InfoPopoverText>
      <InfoPopoverText>
        Conviene sceglierlo breve e descrittivo; modificarlo in seguito può
        invalidare i riferimenti già configurati.
      </InfoPopoverText>
    </InfoPopoverContentWrapper>
  );
}
